import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const AverageAttendanceInLearningCenterSchool = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Average attendance in learning center / school (%)" />
    </Box>
  );
};
